import React from 'react'

import PropTypes from 'prop-types'

import Tag, {atomTagSizes as SIZES, linkTypes as LINK_TYPES} from '@s-ui/react-atom-tag'

const TYPES = {
  ACCENT: 'accent',
  ACTUALIDAD: 'actualidad',
  CLEAR: 'clear',
  COMPARATIVAS: 'comparativas',
  COMPARATIVO: 'comparativo',
  CONS: 'cons',
  CONSEJOS: 'consejos',
  ERROR: 'error',
  GLOSARIO: 'glosario',
  HAS_STOCK: 'hasStock',
  INFO_LABEL: 'infoLabel',
  IS_FINANCED: 'isFinanced',
  IS_SELECTED: 'isSelected',
  IS_URGENT: 'isUrgent',
  MULTIPROVINCE: 'multiprovince',
  NOVEDADES: 'novedades',
  OFFER: 'offer',
  PATROCINADO: 'patrocinado',
  PRESENTACION: 'presentacion',
  PRIMARY_WITHOUT_HOVER: 'primaryWithoutHover',
  PROS: 'pros',
  PRUEBAS: 'pruebas',
  RANKINGS: 'rankings',
  SUCCESS: 'success',
  TENDENCIAS: 'tendencias',
  VIDEOS: 'videos',
  FILTERS: 'filters',
  WHITE: 'white'
}

const defaultColor = 'gray'

const TagChip = ({type, ...props}) => {
  const colorTypesMapper = {
    [TYPES.ACCENT]: 'accentWithoutHover',
    [TYPES.ACTUALIDAD]: 'teal',
    [TYPES.CLEAR]: 'white',
    [TYPES.COMPARATIVAS]: 'bloodOrange',
    [TYPES.COMPARATIVO]: 'bloodOrange',
    [TYPES.CONSEJOS]: 'purple',
    [TYPES.CONS]: 'cons',
    [TYPES.ERROR]: 'error',
    [TYPES.GLOSARIO]: 'salmon',
    [TYPES.HAS_STOCK]: 'aquaWithoutHover',
    [TYPES.INFO_LABEL]: 'grayDarkWithoutHover',
    [TYPES.IS_FINANCED]: 'blue',
    [TYPES.IS_SELECTED]: 'lightBlue',
    [TYPES.IS_URGENT]: 'bloodOrange',
    [TYPES.MULTIPROVINCE]: 'aquaWithoutHover',
    [TYPES.NOVEDADES]: 'orangeJuice',
    [TYPES.OFFER]: 'offer',
    [TYPES.PATROCINADO]: 'lemon',
    [TYPES.PRESENTACION]: 'aqua',
    [TYPES.PRIMARY_WITHOUT_HOVER]: 'primaryWithoutHover',
    [TYPES.PROS]: 'pros',
    [TYPES.PRUEBAS]: 'blue',
    [TYPES.RANKINGS]: 'lime',
    [TYPES.SUCCESS]: 'success',
    [TYPES.TENDENCIAS]: 'brown',
    [TYPES.VIDEOS]: 'softGreen',
    [TYPES.FILTERS]: 'lightGray',
    [TYPES.WHITE]: 'clear'
  }

  const colorType = colorTypesMapper[type] || defaultColor
  return <Tag type={colorType} {...props} />
}

TagChip.displayName = 'TagChip'

TagChip.propTypes = {
  onClose: PropTypes.func,
  /**
   * Will only be shown if the onClose fn is defined
   */
  closeIcon: PropTypes.node,
  /**
   * onClick event handler. If defined, onClose will be ignored
   */
  onClick: PropTypes.func,
  /**
   * Factory to create links
   */
  linkFactory: PropTypes.func,
  /**
   * link url string
   */
  href: PropTypes.string,
  /**
   * To be used if href is defined
   */
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  /**
   * To be used if href is defined
   */
  rel: PropTypes.arrayOf(PropTypes.oneOf(Object.values(LINK_TYPES))),
  /**
   * tag text
   */
  label: PropTypes.string.isRequired,
  /**
   * Tag type in order to color it as desired
   * from a high order component.
   */
  type: PropTypes.oneOf(Object.values(TYPES)),
  /**
   * Tag size (small, medium, large), defaults to 'medium'
   */
  size: PropTypes.oneOf(Object.values(SIZES)),
  /**
   * Custom icon
   */
  icon: PropTypes.node,
  /**
   * Actionable tags can have iconPlacement='right'
   */
  iconPlacement: PropTypes.oneOf(['right', 'left']),
  /**
   * true for making it responsive layout. keep large size in mobile
   */
  responsive: PropTypes.bool
}

export {LINK_TYPES as linkTypes}
export {SIZES as tagChipSizes}
export {TYPES as tagChipTypes}
export default TagChip
